/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { images } from '../../../assets';
import notify from '../../../utils/notify';
import { notifyMessages } from '../../../core/constant';
import DarkBtn from '../Buttons/DarkBtn';

export const ResponsiveDrawer = ({ headerData }) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const { pathname } = useLocation();

  const { userDetails } = useSelector((userState) => userState.user);

  const searchAllLink = `/search/artworks/search-all?query=search-all`;

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
    setState({
      top: false,
      left: false,
      bottom: false,
      right: false,
    });
  }

  const toggleDrawer = (anchor, open) => (event) => {
    if (pathname.includes('personalize') && !userDetails?.user?.is_completed_seller) {
      notify(notifyMessages?.completePersonalization, 'error');
      return;
    }
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <>
      <Box
        sx={{
          width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 'auto',
        }}
        role="presentation"
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <div style={{ textAlign: 'end', paddingTop: '10px', paddingRight: '10px' }}>
          <CloseIcon />
        </div>
      </Box>
      <Box>
        <div className="mobilemenu">
          {userDetails?.token ? (
            <>
              <Typography className="seller-art-heading">
                <Link href="/dashboard" to="/dashboard" onClick={() => handleDrawerToggle()} className="menumaintext">
                  Dashboard
                </Link>
              </Typography>
              <Typography className="seller-art-heading">
                <Link
                  href={`${process.env.REACT_APP_USER_APP_URL}artist/${userDetails?.user?.v_fname}-${userDetails?.user?.v_lname}/${userDetails?.user?.id}`}
                  to={`${process.env.REACT_APP_USER_APP_URL}artist/${userDetails?.user?.v_fname}-${userDetails?.user?.v_lname}/${userDetails?.user?.id}`}
                  onClick={() => handleDrawerToggle()}
                  className="menumaintext"
                >
                  View Portfolio
                </Link>
              </Typography>
              <Typography className="seller-art-heading">
                <Link
                  href={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
                  to={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
                  onClick={() => handleDrawerToggle()}
                  className="menumaintext"
                >
                  Explore
                </Link>
              </Typography>
            </>
          ) : (
            <div>
              {/* <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                  <Typography>
                    {' '}
                    <Link
                      href={`${process.env.REACT_APP_USER_APP_URL}search/artworks/search-all`}
                      to={`${process.env.REACT_APP_USER_APP_URL}search/artworks/search-all`}
                      className="menumaintext"
                    >
                      Buy Art
                    </Link>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className="seller-art-heading">
                    <Link
                      onClick={() => handleDrawerToggle()}
                      href={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
                      to={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
                    >
                      Free Matchmaking Tool
                    </Link>
                  </Typography>
                  {headerData?.headerCategories?.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Accordion key={index} className="inner-according">
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel3a-header"
                          >
                            <Typography>{item?.v_name}</Typography>
                          </AccordionSummary>

                          <AccordionDetails>
                            <Typography>
                             
                              <Accordion className="submenu">
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel3a-header"
                                >
                                  <Typography>Size</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Typography>
                                    <ul>
                                      {headerData?.size?.map((e, i) => {
                                        return (
                                          <li key={i} onClick={() => handleDrawerToggle()}>
                                            <Link
                                              href={`${process.env.REACT_APP_USER_APP_URL}${
                                                item?.v_slug
                                              }?artwork_size=${e?.id ? e?.id : e?.slug}`}
                                              to={`${process.env.REACT_APP_USER_APP_URL}${item?.v_slug}?artwork_size=${
                                                e?.id ? e?.id : e?.slug
                                              }`}
                                            >
                                              {e?.name}
                                            </Link>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </Typography>
                                </AccordionDetails>
                              </Accordion>
                            
                              <Accordion className="submenu">
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel3a-header"
                                >
                                  <Typography>Price</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Typography>
                                    <ul>
                                      {headerData?.price?.map((e, i) => {
                                        return (
                                          <li key={i} onClick={() => handleDrawerToggle()}>
                                            <Link
                                              href={`${process.env.REACT_APP_USER_APP_URL}${item?.v_slug}?price=${e?.id}`}
                                              to={`${process.env.REACT_APP_USER_APP_URL}${item?.v_slug}?price=${e?.id}`}
                                            >
                                              {e?.v_title}
                                            </Link>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </Typography>
                                </AccordionDetails>
                              </Accordion>
                            
                              <Accordion className="submenu">
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel3a-header"
                                >
                                  <Typography>Subject</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Typography>
                                    <ul>
                                      {headerData?.subject?.map((e, i) => {
                                        return (
                                          <li key={i} onClick={() => handleDrawerToggle()}>
                                            <Link
                                              href={`${process.env.REACT_APP_USER_APP_URL}${item?.v_slug}?subject=${e?.id}`}
                                              to={`${process.env.REACT_APP_USER_APP_URL}${item?.v_slug}?subject=${e?.id}`}
                                            >
                                              {e?.v_name}
                                            </Link>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </Typography>
                                </AccordionDetails>
                              </Accordion>
                           
                              <Accordion className="submenu">
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel3a-header"
                                >
                                  <Typography>Style</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Typography>
                                    <ul>
                                      {headerData?.style?.map((e, i) => {
                                        return (
                                          <li key={i} onClick={() => handleDrawerToggle()}>
                                            <Link
                                              href={`${process.env.REACT_APP_USER_APP_URL}${item?.v_slug}?style=${e?.id}`}
                                              to={`${process.env.REACT_APP_USER_APP_URL}${item?.v_slug}?style=${e?.id}`}
                                            >
                                              {e?.v_name}
                                            </Link>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </Typography>
                                </AccordionDetails>
                              </Accordion>
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      </React.Fragment>
                    );
                  })}
                </AccordionDetails>
              </Accordion> */}

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                  <Typography>
                    <Link
                      onClick={() => handleDrawerToggle()}
                      href={`${process.env.REACT_APP_USER_APP_URL}search/artworks/search-all`}
                      to={`${process.env.REACT_APP_USER_APP_URL}search/artworks/search-all`}
                      className="menumaintext"
                    >
                      Buy Art
                    </Link>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Accordion className="inner-according">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel3a-header"
                    >
                      <img
                        src={headerData?.discoverArtForYou?.icon_image || images.searchNew}
                        alt="top bar"
                        className="buy-art-img-mobile"
                      />
                      <Typography>{headerData?.discoverArtForYou?.title}</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} className="grid-padd">
                          <Typography variant="h3" className="font16px subject-text-new">
                            Subject
                          </Typography>
                          {headerData?.discoverArtForYou?.subject?.map((e, index) => (
                            <Typography
                              key={index}
                              variant="h6"
                              onClick={() => {
                                handleDrawerToggle();
                              }}
                              className="font16px geometry-text"
                            >
                              <Link
                                href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&subject=${e?.id}`}
                                to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&subject=${e?.id}`}
                              >
                                {e?.v_name}
                              </Link>
                            </Typography>
                          ))}
                        </Grid>
                        <Grid item xs={12} className="grid-padd">
                          <Typography variant="h3" className="font16px subject-text-new">
                            Medium
                          </Typography>
                          {headerData?.discoverArtForYou?.medium?.map((e, index) => (
                            <Typography
                              key={index}
                              variant="h6"
                              onClick={() => {
                                handleDrawerToggle();
                              }}
                              className="font16px geometry-text"
                            >
                              <Link
                                href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&medium=${e?.id}`}
                                to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&medium=${e?.id}`}
                              >
                                {e?.v_name}
                              </Link>
                            </Typography>
                          ))}
                        </Grid>
                        <Grid item xs={12} className="grid-padd">
                          <Typography variant="h3" className="font16px subject-text-new">
                            Style
                          </Typography>
                          {headerData?.discoverArtForYou?.style?.map((e, index) => (
                            <Typography
                              key={index}
                              variant="h6"
                              onClick={() => {
                                handleDrawerToggle();
                              }}
                              className="font16px geometry-text"
                            >
                              <Link
                                href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&style=${e?.id}`}
                                to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&style=${e?.id}`}
                              >
                                {e?.v_name}
                              </Link>
                            </Typography>
                          ))}
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="inner-according">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel3a-header"
                    >
                      <img
                        src={headerData?.findThePerfectFit?.icon_image || images.scale}
                        alt="top bar"
                        className="buy-art-img-mobile"
                      />
                      <Typography>{headerData?.findThePerfectFit?.title}</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Grid container spacing={2}>
                        {headerData?.findThePerfectFit?.size?.map((e, index) => (
                          <Grid
                            key={index}
                            item
                            xs={12}
                            onClick={() => {
                              handleDrawerToggle();
                            }}
                            className="grid-center"
                          >
                            <Typography variant="h3" className="font14px subject-text-new">
                              <Link
                                href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${
                                  e?.id ? e?.id : e?.slug
                                }`}
                                to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${
                                  e?.id ? e?.id : e?.slug
                                }`}
                              >
                                {e?.name}
                              </Link>
                            </Typography>
                            <Link
                              href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${
                                e?.id ? e?.id : e?.slug
                              }`}
                              to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${
                                e?.id ? e?.id : e?.slug
                              }`}
                            >
                              <img
                                src={e?.v_image ? e?.v_image : images?.small}
                                alt="top bar"
                                className="header-size-img "
                                height={115}
                                width={115}
                                onClick={() => {
                                  handleDrawerToggle();
                                }}
                              />
                            </Link>
                            <Typography
                              variant="h6"
                              onClick={() => {
                                handleDrawerToggle();
                              }}
                              className="font10px seeall-text-new"
                            >
                              <Link
                                href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${
                                  e?.id ? e?.id : e?.slug
                                }`}
                                to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${
                                  e?.id ? e?.id : e?.slug
                                }`}
                              >
                                See All
                              </Link>
                            </Typography>
                          </Grid>
                        ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="inner-according">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel3a-header"
                    >
                      <img
                        src={headerData?.artForYourBudget?.icon_image || images.budget}
                        alt="top bar"
                        className="buy-art-img-mobile"
                      />
                      <Typography>{headerData?.artForYourBudget?.title}</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Grid container spacing={2}>
                        {headerData?.artForYourBudget?.price?.map((e, index) => (
                          <Grid key={index} item xs={12} className="grid-center">
                            <Typography
                              variant="h3"
                              onClick={() => {
                                handleDrawerToggle();
                              }}
                              className="font14px subject-text-new"
                            >
                              <Link
                                href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                                to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                              >
                                {e?.v_title}
                              </Link>
                            </Typography>
                            <Link
                              href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                              to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                            >
                              <img
                                src={e?.v_image ? e?.v_image : images?.star}
                                alt="top bar"
                                height={115}
                                width={115}
                                onClick={() => {
                                  handleDrawerToggle();
                                }}
                                className="budget-size-img "
                              />
                            </Link>
                            <Typography
                              variant="h6"
                              onClick={() => {
                                handleDrawerToggle();
                              }}
                              className="font10px seeall-text-new"
                            >
                              <Link
                                href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                                to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                              >
                                See All
                              </Link>
                            </Typography>
                          </Grid>
                        ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="inner-according">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel3a-header"
                    >
                      <img
                        src={headerData?.artNearYou?.icon_image || images.locationNew}
                        alt="top bar"
                        className="buy-art-img-mobile"
                      />
                      <Typography>{headerData?.artNearYou?.title}</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Grid container spacing={2}>
                        {headerData?.artNearYou?.locations?.map((e, index) =>
                          e?.cities && e?.cities?.length > 0 ? (
                            <Grid key={index} item xs={12} className="grid-padd">
                              <Typography variant="h3" className="font14px subject-text-new">
                                {e?.v_title}
                              </Typography>
                              {e?.cities?.map((city, i) => (
                                <Typography
                                  key={i}
                                  variant="h6"
                                  onClick={() => {
                                    handleDrawerToggle();
                                  }}
                                  className="font12px geometry-text"
                                >
                                  <Link
                                    href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&location=${city?.id}`}
                                    to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&location=${city?.id}`}
                                  >
                                    {city?.v_title}
                                  </Link>
                                </Typography>
                              ))}
                            </Grid>
                          ) : null,
                        )}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="inner-according">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel3a-header"
                    >
                      <img
                        src={headerData?.curatedSelections?.icon_image || images.curated}
                        alt="top bar"
                        className="buy-art-img-mobile"
                      />
                      <Typography>{headerData?.curatedSelections?.title}</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Typography variant="h3" className="font14px subject-text-new">
                        {headerData?.curatedSelections?.title}
                      </Typography>
                      {headerData?.curatedSelections?.curated_sections?.map((e, index) => (
                        <Typography
                          key={index}
                          variant="h6"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            handleDrawerToggle();
                          }}
                          className="font12px geometry-text"
                        >
                          <Link
                            href={`${process.env.REACT_APP_USER_APP_URL}section/${e?.slug}`}
                            to={`${process.env.REACT_APP_USER_APP_URL}section/${e?.slug}`}
                          >
                            {e?.title}
                          </Link>
                        </Typography>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                  <div
                  // onClick={() => {
                  //   handleDrawerToggle();
                  // }}
                  >
                    <Link
                      href={`${process.env.REACT_APP_USER_APP_URL}blog`}
                      to={`${process.env.REACT_APP_USER_APP_URL}blog`}
                    >
                      <div
                        // expandIcon={<ExpandMoreIcon />}
                        // aria-controls="panel1a-content"
                        // id="panel3a-header"
                        className="inner-according-last-section"
                      >
                        <img
                          src={headerData?.beInspired?.icon_image || images.inspired}
                          alt="top bar"
                          className="buy-art-img-mobile"
                        />
                        <Typography>{headerData?.beInspired?.title}</Typography>
                      </div>
                    </Link>
                  </div>
                  <div className="lastbtn">
                    <Link
                      onClick={() => handleDrawerToggle()}
                      href={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
                      to={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
                    >
                      <DarkBtn title="Sign Up For Our Matchmaker" />
                    </Link>
                  </div>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                  <Typography>
                    <Link onClick={() => handleDrawerToggle()} href="/signup" to="/signup">
                      Sell Art
                    </Link>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <AccordionSummary aria-controls="panel1a-content" id="panel3a-header">
                    <img
                      src={headerData?.sellArts?.createAnAccount?.icon_image || images.createAccount}
                      alt="top bar"
                      className="buy-art-img-mobile"
                    />
                    <Typography>
                      <Link onClick={() => handleDrawerToggle()} href="/signup" to="/signup">
                        {headerData?.sellArts?.createAnAccount?.title}
                      </Link>
                    </Typography>
                  </AccordionSummary>
                  <AccordionSummary aria-controls="panel1a-content" id="panel3a-header">
                    <img
                      src={headerData?.sellArts?.howItWorks?.icon_image || images.works}
                      alt="top bar"
                      className="buy-art-img-mobile"
                    />
                    <Typography>
                      <Link
                        onClick={() => handleDrawerToggle()}
                        href={`${process.env.REACT_APP_USER_APP_URL}about-us`}
                        to={`${process.env.REACT_APP_USER_APP_URL}about-us`}
                      >
                        {headerData?.sellArts?.howItWorks?.title}
                      </Link>
                    </Typography>
                  </AccordionSummary>
                </AccordionDetails>
              </Accordion>

              {/* <Typography className="seller-art-heading">
                <Link onClick={() => handleDrawerToggle()} href="/signup" to="/signup" className="menumaintext">
                  Sell Art
                </Link>
              </Typography> */}
              <Typography className="seller-art-heading">
                <Link
                  onClick={() => handleDrawerToggle()}
                  href={`${process.env.REACT_APP_USER_APP_URL}about-us`}
                  to={`${process.env.REACT_APP_USER_APP_URL}about-us`}
                  className="menumaintext"
                >
                  About Us
                </Link>
              </Typography>
            </div>
          )}
        </div>
      </Box>
    </>
  );

  return (
    <div>
      {['left'].map((anchor) => (
        <React.Fragment key={anchor}>
          <div
            tabIndex={0}
            role="button"
            onClick={toggleDrawer(anchor, true)}
            style={{ position: 'relative' }}
            className="filter-icon"
          >
            <img src={images.sidebarIcon} aria-label="Open drawer" />
          </div>
          <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
};
